const state = {
  underSaleTypes:[{txt:`件`,val:1},{txt:`KG`,val:2}],
  underStatusList:[
    {val:'',txt:'全部'},
    // {val:'1',txt:'待审核'},
    // {val:'2',txt:'机审通过'},
    // {val:'3',txt:'机审失败'},
    // {val:'4',txt:'人审通过'},
    // {val:'5',txt:'人审失败'},
    {val:'6',txt:'上架'},
    {val:'7',txt:'下架'},
    {val:'8',txt:'禁用'}
  ],
}
const mutations = {
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/product.js